/**
*
* StepTwo
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Transition } from 'react-transition-group';

import appConfig from 'appConfig';
import { Button, CopyTextBox, AnchorLink } from '@pearsontechnology/aero-components';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import enhanceWithChildrenHeight from 'hocs/enhanceWithChildrenHeight';

import {
  GrowingWrapper,
  VerticalSeparator,
  StepActions,
} from './styles';
import messages from './messages';

const EnhancedGrowingWrapper = enhanceWithChildrenHeight(GrowingWrapper);

const StepTwo = ({ active, back, next }) => (
  <Transition
    in={active}
    timeout={300}
    unmountOnExit
  >
    {(state) => (
      <EnhancedGrowingWrapper transitionState={state}>
        <VerticalSeparator>
          <FormattedMessage {...messages.createDirectoryText} />
        </VerticalSeparator>
        <VerticalSeparator>
          <CopyTextBox
            grey
            textType="code"
            value={`${messages.createCode} ${intl.formatMessage(messages.myPluginCode)}`}
            notificationLabel={intl.formatMessage(messages.copied)}
          />
        </VerticalSeparator>
        <VerticalSeparator>
          <FormattedMessage
            {...messages.createDocumentationText}
            values={{
              developerDocsLink: <AnchorLink iconRight iconSize={18} icon="open_in_new" href={appConfig.getDeveloperDocsURL()} target="_blank">
                {intl.formatMessage(messages.developerDocsLink)}
              </AnchorLink>,
            }}
          />
        </VerticalSeparator>
        <StepActions>
          <Button onClick={back}>
            <FormattedMessage {...messages.previousStep} />
          </Button>
          <Button primary onClick={next}>
            <FormattedMessage {...messages.nextStep} />
          </Button>
        </StepActions>
      </EnhancedGrowingWrapper>
    )}
  </Transition>
);

StepTwo.propTypes = {
  active: PropTypes.bool,
  back: PropTypes.func,
  next: PropTypes.func,
};

export default StepTwo;
